import React from 'react';
import Shrimmer from '../../Skeleton/Shrimmer';
import SkeletonElement from '../../Skeleton/SkeletonElement';

const APUserTileSkeleton = ({ theme, type }) => {

  const themeClass = theme || 'light';
  const skeletonType = type || '';

  return (
    <div className={`skeleton-wrapper AdminPanelUserTile AdminPanelUserTile-skeleton ${skeletonType}`}>
      <SkeletonElement type="avatar sm" />
      <div>
        <SkeletonElement type="title" />
        <SkeletonElement type="text" />
      </div>
      <Shrimmer />
    </div>
  );
};

export default APUserTileSkeleton;
